<template>
    <ul v-if="$state.invalidos" class="stats eleicoes-estatisticas-invalidos" :class="{ full: !$state.lite }">
        <li v-if="$state.invalidos.abstencao">
            <div class="title">Abstenção</div>
            <div class="value">{{$state.invalidos.abstencao.percentagem}}</div>
            <div class="info">{{$state.invalidos.abstencao.votos}} de {{$state.invalidos.abstencao.total}}</div>
        </li>
        <li v-if="$state.invalidos.brancos">
            <div class="title">Brancos</div>
            <div class="value">{{$state.invalidos.brancos.percentagem}}</div>
            <div class="info">{{$state.invalidos.brancos.votos}} de {{$state.invalidos.brancos.total}}</div>
        </li>
        <li v-if="$state.invalidos.nulos">
            <div class="title">Nulos</div>
            <div class="value">{{$state.invalidos.nulos.percentagem}}</div>
            <div class="info">{{$state.invalidos.nulos.votos}} de {{$state.invalidos.nulos.total}}</div>
        </li>
    </ul>
</template>